import { getLastDayOfCurrentMonth, parseLocalDateString, toLocalDateString } from "@/shared/lib/dates";
import { useEffect, useState, useCallback } from "react";
import { useDashboard } from "../../../lib/useDashboard";

export const useDateEnd = () => {
  const { dateStart, dateEnd, setDateEnd } = useDashboard();
  const [dateEndDate, setDateEndDate] = useState<Date | null>(null);
  const [pickerType, setPickerType] = useState<'year' | 'quarter' | 'month' | 'day'>('day');

  function getPeriodDate(date: Date, type: 'year' | 'quarter' | 'month' | 'day', position: 'start' | 'end' | 'value'): Date {
    const d = new Date(date);
    if (type === 'year') {
      if (position === 'start') return new Date(d.getFullYear(), 0, 1, 0, 0, 0, 0);
      if (position === 'end') return new Date(d.getFullYear(), 11, 31, 23, 59, 59, 999);
    }
    if (type === 'quarter') {
      const quarter = Math.floor(d.getMonth() / 3);
      if (position === 'start') return new Date(d.getFullYear(), quarter * 3, 1, 0, 0, 0, 0);
      if (position === 'end') {
        const endMonth = quarter * 3 + 2;
        return new Date(d.getFullYear(), endMonth + 1, 0, 23, 59, 59, 999);
      }
    }
    if (type === 'month') {
      if (position === 'start') return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
      if (position === 'end') return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
    }
    // day
    if (position === 'start') return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
    if (position === 'end') return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
    return d;
  }

  useEffect(() => {
    if (!dateEnd) {
      const localStorageValue = localStorage.getItem("dateEnd");
      if (localStorageValue) {
        setDateEnd(localStorageValue);
        setDateEndDate(parseLocalDateString(localStorageValue));
      } else {
        const lastDay = getLastDayOfCurrentMonth();
        setDateEnd(toLocalDateString(lastDay));
        setDateEndDate(lastDay);
        localStorage.setItem("dateEnd", toLocalDateString(lastDay));
      }
    } else {
      setDateEndDate(parseLocalDateString(dateEnd));
      localStorage.setItem("dateEnd", dateEnd);
    }
  }, [dateEnd, setDateEnd]);

  const setValue = useCallback((date: Date | null) => {
    if (date) {
      const periodDate = getPeriodDate(date, pickerType, 'end');
      const str = toLocalDateString(periodDate);
      if (dateStart && dateStart > str) return;
      setDateEnd(str);
      localStorage.setItem("dateEnd", str);
    } else {
      setDateEnd("");
      localStorage.removeItem("dateEnd");
    }
  }, [setDateEnd, pickerType, dateStart]);

  return {
    value: dateEndDate,
    setValue,
    pickerType,
    setPickerType
  };
}